module.exports = __webpack_public_path__ + "img/147ne.10ad0c2d.svg";